"use strict";

require("core-js/modules/es.object.freeze");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FatalError = exports.ApiErrorCodes = exports.FolderKeys = void 0;

require("regenerator-runtime/runtime");

var _superagent = _interopRequireDefault(require("superagent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FolderKeys = Object.freeze({
  oktaKey: 'oktaApi',
  identityKey: 'identityApi',
  gwErrorsKey: 'gwErrors'
});
exports.FolderKeys = FolderKeys;
var ApiErrorCodes = Object.freeze({
  genericApiError: 'UNHANDLED_EXCEPTION'
});
exports.ApiErrorCodes = ApiErrorCodes;
var FatalError = {
  title: 'The application has encountered an error',
  message: 'Unhandled exception. An error has occurred and we are unable to perform that action at this time. Please contact us if this problem persists.'
};
exports.FatalError = FatalError;

var ErrorCodesMessagesService = /*#__PURE__*/function () {
  function ErrorCodesMessagesService(baseUrl) {
    _classCallCheck(this, ErrorCodesMessagesService);

    this._baseUrl = baseUrl;
  }
  /**
   * Get the entire list of error codes and error messages
   * @param string folderKey
   */


  _createClass(ErrorCodesMessagesService, [{
    key: "getAllErrors",
    value: function () {
      var _getAllErrors = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var folderKey,
            response,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                folderKey = _args.length > 0 && _args[0] !== undefined ? _args[0] : FolderKeys.oktaKey;
                _context.next = 3;
                return _superagent.default.get("".concat(this._baseUrl, "/api/errorcodes")).query({
                  key: folderKey
                }).set('accept', 'json');

              case 3:
                response = _context.sent;

                if (!(response.body.data && response.body.data.attributes && response.body.data.attributes.errorMessages.length !== 0)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", {
                  errorMapping: response.body.data.attributes
                });

              case 6:
                return _context.abrupt("return", null);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAllErrors() {
        return _getAllErrors.apply(this, arguments);
      }

      return getAllErrors;
    }()
    /**
     * Retrieve the corresponding error message given the error code
     * @param string errorCode
     * @param string folderKey
     */

  }, {
    key: "getErrorMessage",
    value: function () {
      var _getErrorMessage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(errorCode) {
        var folderKey,
            response,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                folderKey = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : FolderKeys.oktaKey;
                _context2.next = 3;
                return _superagent.default.get("".concat(this._baseUrl, "/api/errorcodes")).query({
                  key: folderKey,
                  code: errorCode
                }).set('accept', 'json');

              case 3:
                response = _context2.sent;

                if (!(response.body.data && response.body.data.attributes && response.body.data.attributes.errorMessages.length !== 0)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", {
                  title: response.body.data.attributes.errorMessages[0].messageTitle,
                  message: response.body.data.attributes.errorMessages[0].message
                });

              case 6:
                return _context2.abrupt("return", null);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getErrorMessage(_x) {
        return _getErrorMessage.apply(this, arguments);
      }

      return getErrorMessage;
    }()
  }]);

  return ErrorCodesMessagesService;
}();

exports.default = ErrorCodesMessagesService;
//# sourceMappingURL=ErrorCodesMessagesService.js.map